'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by Administrator on 2016/9/7.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _preselection = require('redux/modules/preselection');

var preselectionActions = _interopRequireWildcard(_preselection);

var _reactRouterRedux = require('react-router-redux');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductPreselection = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch(preselectionActions.load()));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.preselection.data,
    submitData: state.preselection.submitData,
    submitted: state.preselection.submitted,
    detailData: state.preselection.detailData,
    modalProductId: state.preselection.modalProductId,
    detailModalOpened: state.preselection.detailModalOpened
  };
}, (0, _extends3.default)({}, preselectionActions, {
  routerPush: _reactRouterRedux.push
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ProductPreselection, _Component);

  function ProductPreselection() {
    (0, _classCallCheck3.default)(this, ProductPreselection);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ProductPreselection).call(this));

    _this.state = {
      chooseItems: [],
      isPreselectionModalOpened: false,
      currentPage: 0
    };
    return _this;
  }

  (0, _createClass3.default)(ProductPreselection, [{
    key: 'onRemoveItem',
    value: function onRemoveItem(product) {
      var _this2 = this;

      var removeFromPreselection = this.props.removeFromPreselection;

      if (removeFromPreselection) {
        removeFromPreselection(product).then(function () {
          _this2.setState({
            currentPage: 0
          });
        });
      }
    }
  }, {
    key: 'onChooseItem',
    value: function onChooseItem(product) {
      var _props = this.props;
      var checkChanged = _props.checkChanged;
      var data = _props.data;
      var currentPage = this.state.currentPage;

      if (checkChanged) {
        checkChanged((0, _extends3.default)({}, product, { selected: product.selected === '1' ? '0' : '1' }), data.orderNumber, currentPage);
      }
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var _props2 = this.props;
      var submit = _props2.submit;
      var data = _props2.data;
      var routerPush = _props2.routerPush;

      if (submit && data) {
        submit(data.productsSummarizing, data.orderNumber).then(function (nextData) {
          if (nextData.isValid) {
            routerPush('/orderwriting/' + nextData.orderNumber);
          }
        });
      }
    }
  }, {
    key: 'onCloseSuccessModal',
    value: function onCloseSuccessModal() {
      var clearSubmitError = this.props.clearSubmitError;

      if (clearSubmitError) {
        clearSubmitError();
      }
    }
  }, {
    key: 'onDetailShow',
    value: function onDetailShow(productId) {
      var _props3 = this.props;
      var getDetail = _props3.getDetail;
      var openDetailModal = _props3.openDetailModal;
      var data = _props3.data;

      if (getDetail) {
        getDetail(productId, data.orderNumber).then(function () {
          openDetailModal(productId);
        });
      }
    }
  }, {
    key: 'onDetailModalClose',
    value: function onDetailModalClose() {
      var closeDetailModal = this.props.closeDetailModal;

      if (closeDetailModal) {
        closeDetailModal();
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var load = this.props.load;

      if (load) {
        this.setState({
          currentPage: page
        });
        load(page, true);
      }
    }
  }, {
    key: 'policyChange',
    value: function policyChange(product, newPolicy) {
      var _props4 = this.props;
      var onPolicyChange = _props4.onPolicyChange;
      var data = _props4.data;
      var currentPage = this.state.currentPage;

      if (onPolicyChange) {
        onPolicyChange((0, _extends3.default)({}, product, { policy: newPolicy }), data.orderNumber, currentPage);
      }
    }
  }, {
    key: 'numberChange',
    value: function numberChange(product, newNumber) {
      var _props5 = this.props;
      var onPolicyChange = _props5.onPolicyChange;
      var data = _props5.data;
      var currentPage = this.state.currentPage;

      if (onPolicyChange) {
        onPolicyChange((0, _extends3.default)({}, product, { number: newNumber }), data.orderNumber, currentPage);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props;
      var data = _props6.data;
      var submitData = _props6.submitData;
      var modalProductId = _props6.modalProductId;
      var detailData = _props6.detailData;
      var detailModalOpened = _props6.detailModalOpened;
      var currentPage = this.state.currentPage;

      var styles = require('./ProductPreselection.scss');
      var productsDetailShow = '';
      var footDiv = '';
      var totalPageNumber = 1;
      if (data) {
        var productsDetail = data.productsDetail;
        var productsDetailError = data.productsDetailError;
        var productsDetailRecordCount = data.productsDetailRecordCount;
        var productsDetailPagesize = data.productsDetailPagesize;
        var productsSummarizing = data.productsSummarizing;
        var productsSummarizingError = data.productsSummarizingError;

        totalPageNumber = parseInt(productsDetailRecordCount / productsDetailPagesize, 10);
        if (productsDetailRecordCount % productsDetailPagesize > 0) {
          ++totalPageNumber;
        }
        if (productsDetailError) {
          productsDetailShow = _react2.default.createElement(
            'div',
            null,
            productsDetailError
          );
        } else if (productsDetail instanceof Array) {
          productsDetailShow = _react2.default.createElement(_components.PreSelectionProductComponent, { editable: true, onChooseItem: this.onChooseItem.bind(this),
            policyChange: this.policyChange.bind(this),
            onRemoveItem: this.onRemoveItem.bind(this),
            numberChange: this.numberChange.bind(this),
            onDetailShow: this.onDetailShow.bind(this),
            onDetailModalClose: this.onDetailModalClose.bind(this),
            detailData: detailData,
            detailModalOpened: detailModalOpened,
            modalProductId: modalProductId,
            data: productsDetail });
        }
        if (productsSummarizingError) {
          footDiv = _react2.default.createElement(
            'div',
            null,
            productsSummarizingError
          );
        } else if (productsSummarizing instanceof Array && productsSummarizing.length > 0) {
          footDiv = _react2.default.createElement(
            'table',
            { className: styles.tablee, style: { marginTop: totalPageNumber && totalPageNumber > 1 ? 100 : 100 } },
            _react2.default.createElement(
              'colgroup',
              null,
              _react2.default.createElement('col', { width: '14%' }),
              _react2.default.createElement('col', { width: '14%' }),
              _react2.default.createElement('col', { width: '14%' }),
              _react2.default.createElement('col', { width: '14%' }),
              _react2.default.createElement('col', { width: '14%' }),
              _react2.default.createElement('col', { width: '15%' }),
              _react2.default.createElement('col', { width: '15%' })
            ),
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  '数量'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  '金额'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  '包装费用'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  '服务费用'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  '定制费用'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  '优惠金额'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  '结算金额'
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  productsSummarizing[0].number || ''
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  productsSummarizing[0].money || ''
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  productsSummarizing[0].packagingCost || ''
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  productsSummarizing[0].servicesCost || ''
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  productsSummarizing[0].customCost || ''
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  productsSummarizing[0].policyMoney || ''
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  productsSummarizing[0].sumMoney || ''
                )
              )
            )
          );
        }
      }
      var modalOpened = false;
      var modalText = '';
      if (submitData) {
        if (submitData.isValid === false) {
          modalOpened = true;
          modalText = submitData.message;
          // console.log(modalText);
        }
      }
      return _react2.default.createElement(
        'div',
        null,
        productsDetailShow,
        _react2.default.createElement('div', { className: 'clear' }),
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { selected: currentPage, totalPageNumber: totalPageNumber,
          onPageItemClick: this.onPageItemClick.bind(this) }) : '',
        _react2.default.createElement('div', { className: 'clear' }),
        footDiv,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.SubmitBtn, { btnClick: this.onSubmit.bind(this), text: '结算' }),
        _react2.default.createElement(_components.AttentionSuccessModal, { isOpened: modalOpened,
          loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/zhuce_sucess_1.png") no-repeat' },
          closeModalFunc: this.onCloseSuccessModal.bind(this),
          text: modalText })
      );
    }
  }]);
  return ProductPreselection;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  submitData: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  load: _react.PropTypes.func,
  removeFromPreselection: _react.PropTypes.func,
  onPolicyChange: _react.PropTypes.func,
  productNumberChange: _react.PropTypes.func,
  checkChanged: _react.PropTypes.func,
  clearSubmitError: _react.PropTypes.func,
  submit: _react.PropTypes.func,
  routerPush: _react.PropTypes.func,
  openDetailModal: _react.PropTypes.func,
  closeDetailModal: _react.PropTypes.func,
  getDetail: _react.PropTypes.func,
  error: _react.PropTypes.object,
  submitted: _react.PropTypes.bool,
  detailModalOpened: _react.PropTypes.bool,
  modalProductId: _react.PropTypes.string,
  detailData: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = ProductPreselection;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ProductPreselection/ProductPreselection.js
 ** module id = 1529
 ** module chunks = 0
 **/